module.exports = __webpack_public_path__ + "img/152.72181ec4.jpg";